import { createStore, createLogger } from 'vuex'

import {
    UserModule,
    Store as UserStore,
    State as UserState,
} from '@/store/user.module';

import {
    GalleriesModule,
    Store as GalleriesStore,
    State as GalleriesState,
} from '@/store/galleries.module';

import {
    PhotosModule,
    Store as PhotosStore,
    State as PhotosState,
} from '@/store/photos.module';

import {
    AlertsModule,
    Store as AlertsStore,
    State as AlertsState,
} from '@/store/alerts.module';

import {
    ProfileModule,
    Store as ProfileStore,
    State as ProfileState,
} from '@/store/profile.module';
import {
    ProfilePricesModule,
    Store as ProfilePricesStore,
    State as ProfilePricesState,
} from '@/store/profilePrices.module';

import {
    FaceGroupingModule,
    Store as FaceGroupingStore,
    State as FaceGroupingState,
} from '@/store/faceGrouping.module';

import {
    UploadModule,
    Store as UploadStore,
    State as UploadState,
} from '@/store/upload.module';

export type State = {
    user: UserState,
    galleries: GalleriesState,
    photos: PhotosState,
    alerts: AlertsState,
    profile: ProfileState,
    profilePrices: ProfilePricesState,
    faceGrouping: FaceGroupingState,
    upload: UploadState,
};

export type Store = UserStore<Pick<State, 'user'>> &
    GalleriesStore<Pick<State, 'galleries'>> &
    PhotosStore<Pick<State, 'photos'>> &
    AlertsStore<Pick<State, 'alerts'>> &
    ProfileStore<Pick<State, 'profile'>> &
    ProfilePricesStore<Pick<State, 'profilePrices'>> &
    FaceGroupingStore<Pick<State, 'faceGrouping'>> &
    UploadStore<Pick<State, 'upload'>>;

export const store = createStore({
    plugins:
        process.env.NODE_ENV === 'production'
            ? []
            : [createLogger()],
    modules: {
        user: UserModule,
        galleries: GalleriesModule,
        photos: PhotosModule,
        alerts: AlertsModule,
        profile: ProfileModule,
        profilePrices: ProfilePricesModule,
        faceGrouping: FaceGroupingModule,
        upload: UploadModule,
    },
})

export function useStore(): Store {
    return store as Store
}

export default store
